/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        $('.owl-carousel').owlCarousel({
            loop:true,
            items:1,
            autoplay:true,
            autoplayHoverPause:true,
            nav: true,
            dots: true
            //animateOut: 'fadeOut'
        });

        $(".reg-form-menu-link").click(function(){
          $("#registerModal").modal('show');
        });

        //Header animation
        var animationStart = 50,
        animate = $('#header'),
        fix = $('#fixed-wrap'),
        body = $('body');
        // content = $('.wrap');
        $(window).bind('scroll', function(){
            var offset = $(document).scrollTop();
            animate.addClass('shrink');
            body.addClass('shrink');
            setBodyPadding();
            // fix.addClass('fixed');
            // body.css("padding-top", animate.height());
            if( offset<=animationStart ){
                animate.removeClass('shrink');
                body.removeClass('shrink');
                setBodyPadding();
                // fix.removeClass('fixed');
                // body.css("padding-top", '0px');
            }else {
                animate.addClass('shrink');
                body.addClass('shrink');
                setBodyPadding();
                // fix.addClass('fixed');
                // body.css("padding-top", animate.height());
            }
        });

        function setBodyPadding () {
          var header = $('#fixed-wrap');
          var win = $(this); //this = window
          // if (win.height() >= 820) { /* ... */ }
          console.log(header.outerHeight());
          // if (win.width() <= 768) {
            body.css("padding-top", header.outerHeight());
            // console.log(header.outerHeight());
          // }
        }

        setBodyPadding();
        $(window).on('resize', function(){
          setBodyPadding();
        });
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // Program
    'program': {
      init: function() {
        // $(document).ready(function(){
        //   // console.log($("#fixed-wrap"));
        //   $('html, body').animate({
        //       scrollTop: 550
        //   }, 1000);
        // });
      },
      finalize: function() {
        
      }
    },
    'faculty': {
      init: function() {
        // $(document).ready(function(){
        //   // console.log($("#fixed-wrap"));
        //   $('html, body').animate({
        //       scrollTop: 550
        //   }, 1000);
        // });
      },
      finalize: function() {
        
      }
    },
    'symposium_facts': {
      init: function() {
        // $(document).ready(function(){
        //   // console.log($("#fixed-wrap"));
        //   $('html, body').animate({
        //       scrollTop: 550
        //   }, 1000);
        // });
      },
      finalize: function() {
        
      }
    },
    'symposium_venue': {
      init: function() {
        // $(document).ready(function(){
        //   // console.log($("#fixed-wrap"));
        //   $('html, body').animate({
        //       scrollTop: 550
        //   }, 1000);
        // });
      },
      finalize: function() {
        
      }
    },
    'press': {
      init: function() {
        // $(document).ready(function(){
        //   // console.log($("#fixed-wrap"));
        //   $('html, body').animate({
        //       scrollTop: 550
        //   }, 1000);
        // });
      },
      finalize: function() {
        
      }
    },
    'contact_us': {
      init: function() {
        // $(document).ready(function(){
        //   // console.log($("#fixed-wrap")s);
        //   $('html, body').animate({
        //       scrollTop: 550
        //   }, 1000);
        // });
      },
      finalize: function() {
        
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
